import { FileInput, FileInputProps } from '@mi-front/ui';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box } from '@mui/material';

export function NoFilesSelected(p: { onChange: FileInputProps['onChange'] }) {
  return (
    <Box className="text-muted">
      <div>
        <FileInput
          name="files"
          className="mr-2"
          onChange={p.onChange}
          accept="audio/*,video/mp4,video/x-m4v,video/*"
          startIcon={<AttachFileIcon fontSize="small" />}
        />
      </div>
    </Box>
  );
}
